// extracted by mini-css-extract-plugin
module.exports = {"container":"banner-module--container--1fyTQ"};